import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { PriceFilter as PriceFilterInput } from '../../components/search_filters/filters/price_filter';
import { EAbFiltersPriceGroup, getFiltersPriceGroup } from '../../helpers/ab_filters_price';
import { ISearchPrice } from '../../models/filters/price';
import { IStore } from '../../models/store';
import {
  initialState,
  setDirty,
  setFromPrice,
  setPriceCurrency,
  setPriceType,
  setToPrice,
} from '../../redux/modules/search/price';
import { GenericFilter } from './generic_filter';

interface IProps {
  section: string;
  price: ISearchPrice;
  experiment: EAbFiltersPriceGroup;
// tslint:disable-next-line: no-any
  dispatch: Dispatch<any>;
}

class PriceFilter extends GenericFilter<IProps> {
  protected setDirty(isDirty: boolean) {
    this.props.dispatch(setDirty(isDirty));
  }

  public componentWillMount() {
    this.props.dispatch(setPriceCurrency(initialState.currency));
    this.props.dispatch(setPriceType(initialState.priceType));
  }

  public render() {
    const { section, experiment } = this.props;

    const isNewbuildings = section === 'new-buildings';

    if (!isNewbuildings && experiment === EAbFiltersPriceGroup.NoPriceFilter) {
      return null;
    }

    return (
      <PriceFilterInput
        fromPrice={this.props.price.fromPrice}
        toPrice={this.props.price.toPrice}
        hideFrom={!isNewbuildings && experiment === EAbFiltersPriceGroup.NoFromPriceFilter}

        onChangeFromPrice={(value: number) => this.props.dispatch(setFromPrice(value))}
        onChangeToPrice={(value: number) => this.props.dispatch(setToPrice(value))}
      />
    );
  }
}

class CommercialPriceFilter extends React.Component<IProps> {
  public render() {
    return (
      <PriceFilterInput
        fromPrice={this.props.price.fromPrice}
        toPrice={this.props.price.toPrice}
        currency={this.props.price.currency}
        priceType={this.props.price.priceType}
        priceTypes={[
          {value: 'all', label: 'за все'},
          {value: 'meters', label: 'за м²'},
        ]}

        onChangeFromPrice={(value: number) => this.props.dispatch(setFromPrice(value))}
        onChangeToPrice={(value: number) => this.props.dispatch(setToPrice(value))}
        onChangeCurrency={(value: string) => this.props.dispatch(setPriceCurrency(value))}
        onChangePriceType={(value: string) => this.props.dispatch(setPriceType(value))}
      />
    );
  }
}

class CommercialRentPriceFilter extends React.Component<IProps> {
  public render() {
    return (
      <PriceFilterInput
        fromPrice={this.props.price.fromPrice}
        toPrice={this.props.price.toPrice}
        currency={this.props.price.currency}
        priceType={this.props.price.priceType}
        priceTypes={[
          {value: 'all', label: 'за месяц'},
          {value: 'meters', label: 'за м² в год'},
        ]}

        onChangeFromPrice={(value: number) => this.props.dispatch(setFromPrice(value))}
        onChangeToPrice={(value: number) => this.props.dispatch(setToPrice(value))}
        onChangeCurrency={(value: string) => this.props.dispatch(setPriceCurrency(value))}
        onChangePriceType={(value: string) => this.props.dispatch(setPriceType(value))}
      />
    );
  }
}

const PriceFilterWrapper = connect((state: IStore) => ({
  section: state.mainpage.section,
  price: state.price,
  experiment: getFiltersPriceGroup(state.mainpage.experiments || []),
// tslint:disable-next-line: no-any
}))(PriceFilter as any);

const CommercialPriceFilterWrapper = connect((state: IStore) => ({
  price: state.price,
}))(CommercialPriceFilter);

const CommercialRentPriceFilterWrapper = connect((state: IStore) => ({
  price: state.price,
}))(CommercialRentPriceFilter);

export {
  PriceFilterWrapper as PriceFilter,
  PriceFilter as PriceFilterClass,
  CommercialPriceFilterWrapper as CommercialPriceFilter,
  CommercialPriceFilter as CommercialPriceFilterClass,
  CommercialRentPriceFilterWrapper as CommercialRentPriceFilter,
  CommercialRentPriceFilter as CommercialRentPriceFilterClass,
};
